<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="modal-title">Generate Invoice</h2>
          <p class="modal-subtitle">Create an invoice for {{ data?.fleetName }}.</p>
        </div>
        <button class="close-button" (click)="onClose()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M1 1L11 11M1 11L11 1"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <!-- Invoice Period Section -->
      <div class="form-section">
        <label class="form-label">Choose Invoice Period</label>
        <div class="period-cards">
          <div
            class="period-card"
            [class.selected]="period() === 'current'"
            (click)="onPeriodSelect('current')"
          >
            <img
              src="assets/images/calendar-current.svg"
              alt=""
              class="period-icon"
              width="24"
              height="24"
            />
            <span class="period-label">Current Billing cycle</span>
            <span class="radio-custom" [class.checked]="period() === 'current'"></span>
          </div>
          <div
            class="period-card"
            [class.selected]="period() === 'last'"
            (click)="onPeriodSelect('last')"
          >
            <img
              src="assets/images/calendar-last.svg"
              alt=""
              class="period-icon"
              width="24"
              height="24"
            />
            <span class="period-label">Last Billing cycle</span>
            <span class="radio-custom" [class.checked]="period() === 'last'"></span>
          </div>
          <div
            class="period-card"
            [class.selected]="period() === 'custom'"
            (click)="onPeriodSelect('custom')"
          >
            <img
              src="assets/images/calendar-custom.svg"
              alt=""
              class="period-icon"
              width="24"
              height="24"
            />
            <span class="period-label">Custom range</span>
            <span class="radio-custom" [class.checked]="period() === 'custom'"></span>
          </div>
        </div>

        <div class="form-row" *ngIf="period() === 'custom'">
          <div class="form-group">
            <label id="invoice-from-date-label" class="sr-only">From date</label>
            <app-custom-date-picker
              aria-labelledby="invoice-from-date-label"
              placeholder="From"
              mode="date"
              [showTime]="false"
              [fixedOverlay]="true"
              [allowPastDates]="true"
              [maxDate]="maxCustomRangeDate"
              [ngModel]="customStartDate()"
              (dateTimeChange)="onCustomStartDateChange($event)"
            ></app-custom-date-picker>
          </div>
          <div class="form-group">
            <label id="invoice-to-date-label" class="sr-only">To date</label>
            <app-custom-date-picker
              aria-labelledby="invoice-to-date-label"
              placeholder="To"
              mode="date"
              [showTime]="false"
              [fixedOverlay]="true"
              dropdownAlign="right"
              [allowPastDates]="true"
              [minDate]="customStartDate()"
              [maxDate]="maxCustomRangeDate"
              [ngModel]="customEndDate()"
              (dateTimeChange)="onCustomEndDateChange($event)"
            ></app-custom-date-picker>
          </div>
        </div>
      </div>

      <!-- Past Invoice Section -->
      <app-section-accordion
        [title]="'Past invoice'"
        [isExpanded]="showPastInvoices()"
        (toggle)="togglePastInvoices()"
      >
        <p class="past-invoice-count" *ngIf="!pastInvoicesLoading()">
          {{ pastInvoices().length }} closed billing cycle{{
            pastInvoices().length === 1 ? '' : 's'
          }}
        </p>
        <p class="past-invoice-count" *ngIf="pastInvoicesLoading()">Loading invoices…</p>
        <div class="past-invoice-table" *ngIf="!pastInvoicesLoading() && pastInvoices().length > 0">
          <div class="past-invoice-row past-invoice-header">
            <span>Invoice</span>
            <span>Billing cycle</span>
            <span>Action</span>
          </div>
          <div class="past-invoice-row" *ngFor="let invoice of pastInvoices()">
            <span>{{ invoice.invoiceNumber }}</span>
            <span>{{ invoice.billingCycle }}</span>
            <button
              class="link-button"
              [disabled]="downloading()"
              (click)="onDownloadPastInvoice(invoice)"
            >
              Download
            </button>
          </div>
        </div>
      </app-section-accordion>

      <!-- Generated Invoice Preview -->
      <div class="form-section" *ngIf="generatedInvoice() as invoice">
        <label class="form-label">Generated Invoice</label>
        <div class="generated-invoice-card">
          <span class="generated-invoice-icon">📄</span>
          <div class="generated-invoice-text">
            <span class="generated-invoice-fleet">{{ data?.fleetName }}</span>
            <span class="generated-invoice-period"
              >{{ invoice.invoice_number }} · {{ periodLabel() }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <button class="btn btn-large btn-secondary" (click)="onClose()">Cancel</button>
        <button
          *ngIf="!generatedInvoice()"
          class="btn btn-large btn-primary"
          [disabled]="isGenerateDisabled()"
          (click)="onGenerate()"
        >
          {{ generating() ? 'Generating…' : 'Generate' }}
        </button>
        <button
          *ngIf="generatedInvoice()"
          class="btn btn-large btn-primary"
          [disabled]="downloading()"
          (click)="onDownloadPdf()"
        >
          {{ downloading() ? 'Downloading…' : 'Download pdf' }}
        </button>
      </div>
    </div>
  </div>
</div>
